// GENERATED from tools/error-code-registry.yaml by tools/generate-error-codes.py - DO NOT HAND-EDIT. Edit the registry and re-run the generator.
//
// Chat error codes (SPEC-SERVICE-INTEGRATION RULE-INTEG-029, SPEC-FRONTEND-RULE-088, D-318).
// The UI renders ONLY the identifier `HIBAKOD #<displayCode> - ref <request_id>`; no
// per-code message exists in web/src. What each code MEANS is internal support text,
// published in docs/runbooks/error-codes.md. displayCode is PERMANENT and never reused.

export type ErrorClass = "auth" | "request" | "retrieval" | "upstream" | "internal";

export type ErrorCode =
  | "retrieval_auth_denied"
  | "session_binding_rejected"
  | "model_region_forbidden"
  | "bounds_platform_admin_only"
  | "retrieval_provider_invalid"
  | "prompt_override_too_long"
  | "invalid_message_shape"
  | "system_role_not_accepted"
  | "blank_value"
  | "parameter_not_accepted"
  | "message_too_long"
  | "conversation_hidden"
  | "hide_route_moved"
  | "report_predates_ai_marking"
  | "context_files_over_budget"
  | "bounds_out_of_range"
  | "bounds_order"
  | "floor_below_smallest_allowed"
  | "change_reason_required"
  | "change_reason_invalid"
  | "bounds_update_not_alone"
  | "retention_bounds_conflict"
  | "source_read_unavailable"
  | "context_files_unavailable"
  | "retrieval_answer_interrupted"
  | "upstream_timeout"
  | "upstream_stream_error"
  | "upstream_incomplete"
  | "upstream_busy"
  | "upstream_unavailable"
  | "upstream_refused"
  | "stream_internal_error"
  | "untrusted_content_unsafe"
  | "transcript_unavailable"
  | "bounds_audit_unavailable"
  | "retention_bounds_unavailable"
  | "saved_not_shown"
  | "legal_notice_unavailable";

export interface ErrorCodeSpec {
  readonly displayCode: number;
  readonly namespace: string;
  readonly class: ErrorClass;
  readonly httpStatus: number;
  /** Coarse details.reason for anonymous lanes; null when the reason is not sensitive. */
  readonly reasonPublic: string | null;
}

export const ERROR_CODES: Readonly<Record<ErrorCode, ErrorCodeSpec>> = Object.freeze({
  retrieval_auth_denied: {
    displayCode: 1001,
    namespace: "VERISA.RAG.RETRIEVAL_AUTH_DENIED",
    class: "auth",
    httpStatus: 502,
    reasonPublic: "denied",
  },
  session_binding_rejected: {
    displayCode: 1002,
    namespace: "VERISA.CHAT.SESSION_BINDING_REJECTED",
    class: "auth",
    httpStatus: 403,
    reasonPublic: null,
  },
  model_region_forbidden: {
    displayCode: 1003,
    namespace: "VERISA.INFERENCE.MODEL_REGION_FORBIDDEN",
    class: "auth",
    httpStatus: 403,
    reasonPublic: "denied",
  },
  bounds_platform_admin_only: {
    displayCode: 1004,
    namespace: "VERISA.PROVENANCE.BOUNDS_PLATFORM_ADMIN_ONLY",
    class: "auth",
    httpStatus: 403,
    reasonPublic: null,
  },
  retrieval_provider_invalid: {
    displayCode: 2001,
    namespace: "VERISA.RAG.RETRIEVAL_PROVIDER_INVALID",
    class: "request",
    httpStatus: 422,
    reasonPublic: null,
  },
  prompt_override_too_long: {
    displayCode: 2002,
    namespace: "VERISA.CHAT.PROMPT_OVERRIDE_TOO_LONG",
    class: "request",
    httpStatus: 422,
    reasonPublic: null,
  },
  invalid_message_shape: {
    displayCode: 2003,
    namespace: "VERISA.CHAT.INVALID_MESSAGE_SHAPE",
    class: "request",
    httpStatus: 422,
    reasonPublic: null,
  },
  system_role_not_accepted: {
    displayCode: 2004,
    namespace: "VERISA.CHAT.SYSTEM_ROLE_NOT_ACCEPTED",
    class: "request",
    httpStatus: 422,
    reasonPublic: null,
  },
  blank_value: {
    displayCode: 2005,
    namespace: "VERISA.API.BLANK_VALUE",
    class: "request",
    httpStatus: 400,
    reasonPublic: null,
  },
  parameter_not_accepted: {
    displayCode: 2006,
    namespace: "VERISA.CHAT.PARAMETER_NOT_ACCEPTED",
    class: "request",
    httpStatus: 422,
    reasonPublic: null,
  },
  message_too_long: {
    displayCode: 2007,
    namespace: "VERISA.CHAT.MESSAGE_TOO_LONG",
    class: "request",
    httpStatus: 413,
    reasonPublic: null,
  },
  conversation_hidden: {
    displayCode: 2008,
    namespace: "VERISA.CHAT.CONVERSATION_HIDDEN",
    class: "request",
    httpStatus: 410,
    reasonPublic: null,
  },
  hide_route_moved: {
    displayCode: 2009,
    namespace: "VERISA.CHAT.HIDE_ROUTE_MOVED",
    class: "request",
    httpStatus: 410,
    reasonPublic: null,
  },
  report_predates_ai_marking: {
    displayCode: 2010,
    namespace: "VERISA.INSIGHTS.REPORT_PREDATES_AI_MARKING",
    class: "request",
    httpStatus: 409,
    reasonPublic: null,
  },
  context_files_over_budget: {
    displayCode: 2011,
    namespace: "VERISA.CHAT.CONTEXT_FILES_OVER_BUDGET",
    class: "request",
    httpStatus: 413,
    reasonPublic: null,
  },
  bounds_out_of_range: {
    displayCode: 2014,
    namespace: "VERISA.PROVENANCE.BOUNDS_OUT_OF_RANGE",
    class: "request",
    httpStatus: 400,
    reasonPublic: null,
  },
  bounds_order: {
    displayCode: 2015,
    namespace: "VERISA.PROVENANCE.BOUNDS_ORDER",
    class: "request",
    httpStatus: 400,
    reasonPublic: null,
  },
  floor_below_smallest_allowed: {
    displayCode: 2016,
    namespace: "VERISA.PROVENANCE.FLOOR_BELOW_SMALLEST_ALLOWED",
    class: "request",
    httpStatus: 400,
    reasonPublic: null,
  },
  change_reason_required: {
    displayCode: 2017,
    namespace: "VERISA.PROVENANCE.CHANGE_REASON_REQUIRED",
    class: "request",
    httpStatus: 400,
    reasonPublic: null,
  },
  change_reason_invalid: {
    displayCode: 2018,
    namespace: "VERISA.PROVENANCE.CHANGE_REASON_INVALID",
    class: "request",
    httpStatus: 400,
    reasonPublic: null,
  },
  bounds_update_not_alone: {
    displayCode: 2019,
    namespace: "VERISA.PROVENANCE.BOUNDS_UPDATE_NOT_ALONE",
    class: "request",
    httpStatus: 400,
    reasonPublic: null,
  },
  retention_bounds_conflict: {
    displayCode: 2020,
    namespace: "VERISA.PROVENANCE.RETENTION_BOUNDS_CONFLICT",
    class: "request",
    httpStatus: 409,
    reasonPublic: null,
  },
  source_read_unavailable: {
    displayCode: 3012,
    namespace: "VERISA.RAG.SOURCE_READ_UNAVAILABLE",
    class: "retrieval",
    httpStatus: 502,
    reasonPublic: null,
  },
  context_files_unavailable: {
    displayCode: 3013,
    namespace: "VERISA.CHAT.CONTEXT_FILES_UNAVAILABLE",
    class: "retrieval",
    httpStatus: 502,
    reasonPublic: null,
  },
  retrieval_answer_interrupted: {
    displayCode: 3014,
    namespace: "VERISA.RAG.RETRIEVAL_ANSWER_INTERRUPTED",
    class: "retrieval",
    httpStatus: 502,
    reasonPublic: null,
  },
  upstream_timeout: {
    displayCode: 4001,
    namespace: "VERISA.UPSTREAM.UPSTREAM_TIMEOUT",
    class: "upstream",
    httpStatus: 504,
    reasonPublic: null,
  },
  upstream_stream_error: {
    displayCode: 4002,
    namespace: "VERISA.UPSTREAM.UPSTREAM_STREAM_ERROR",
    class: "upstream",
    httpStatus: 502,
    reasonPublic: null,
  },
  upstream_incomplete: {
    displayCode: 4003,
    namespace: "VERISA.UPSTREAM.UPSTREAM_INCOMPLETE",
    class: "upstream",
    httpStatus: 502,
    reasonPublic: null,
  },
  upstream_busy: {
    displayCode: 4004,
    namespace: "VERISA.UPSTREAM.UPSTREAM_BUSY",
    class: "upstream",
    httpStatus: 429,
    reasonPublic: "busy",
  },
  upstream_unavailable: {
    displayCode: 4005,
    namespace: "VERISA.UPSTREAM.UPSTREAM_UNAVAILABLE",
    class: "upstream",
    httpStatus: 503,
    reasonPublic: null,
  },
  upstream_refused: {
    displayCode: 4006,
    namespace: "VERISA.UPSTREAM.UPSTREAM_REFUSED",
    class: "upstream",
    httpStatus: 502,
    reasonPublic: null,
  },
  stream_internal_error: {
    displayCode: 5001,
    namespace: "VERISA.CHAT.STREAM_INTERNAL_ERROR",
    class: "internal",
    httpStatus: 500,
    reasonPublic: null,
  },
  untrusted_content_unsafe: {
    displayCode: 5002,
    namespace: "VERISA.CHAT.UNTRUSTED_CONTENT_UNSAFE",
    class: "internal",
    httpStatus: 500,
    reasonPublic: null,
  },
  transcript_unavailable: {
    displayCode: 5003,
    namespace: "VERISA.CHAT.TRANSCRIPT_UNAVAILABLE",
    class: "internal",
    httpStatus: 503,
    reasonPublic: null,
  },
  bounds_audit_unavailable: {
    displayCode: 5004,
    namespace: "VERISA.PROVENANCE.BOUNDS_AUDIT_UNAVAILABLE",
    class: "internal",
    httpStatus: 503,
    reasonPublic: null,
  },
  retention_bounds_unavailable: {
    displayCode: 5005,
    namespace: "VERISA.PROVENANCE.RETENTION_BOUNDS_UNAVAILABLE",
    class: "internal",
    httpStatus: 503,
    reasonPublic: null,
  },
  saved_not_shown: {
    displayCode: 5006,
    namespace: "VERISA.CHANNEL.SAVED_NOT_SHOWN",
    class: "internal",
    httpStatus: 503,
    reasonPublic: null,
  },
  legal_notice_unavailable: {
    displayCode: 5007,
    namespace: "VERISA.CHANNEL.LEGAL_NOTICE_UNAVAILABLE",
    class: "internal",
    httpStatus: 503,
    reasonPublic: null,
  },
});

export function isErrorCode(value: unknown): value is ErrorCode {
  return typeof value === "string" && Object.prototype.hasOwnProperty.call(ERROR_CODES, value);
}
